/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../../theme/theme"
import { css } from "@mui/material"
import { Alert, Typography } from "@mui/material"
import { SaveOutlined } from "@mui/icons-material"
import { useTranslation } from "react-i18next"
import { mobileCss } from "../../util/isMobile"

const AutoSaveAlertStyle = withMyTheme((theme) => css`
    max-width: 80vw;
    margin-bottom: 1.5rem;
    border-radius: 12px;
    
    .MuiAlert-icon {
        color: ${theme.palette.success.main};
    }
    
    .MuiAlert-message {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }
    
    ${mobileCss(`
        max-width: 90vw;
        font-size: 0.9rem;
    `)}
`)

const AutoSaveTitleStyle = withMyTheme((theme) => css`
    font-weight: 600;
    color: ${theme.palette.success.dark};
    margin: 0;
`)

const AutoSaveDescriptionStyle = withMyTheme((theme) => css`
    color: ${theme.palette.success.dark};
    margin: 0;
    opacity: 0.9;
`)

export const AutoSaveInfo = () => {
    const { t } = useTranslation()
    
    return (
        <Alert 
            severity="success" 
            icon={<SaveOutlined />}
            css={AutoSaveAlertStyle}
        >
            <div>
                <Typography css={AutoSaveTitleStyle}>
                    {t('questionnaire.autoSave.title')}
                </Typography>
                <Typography css={AutoSaveDescriptionStyle}>
                    {t('questionnaire.autoSave.description')}
                </Typography>
            </div>
        </Alert>
    )
}